import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'myabvv-pagination',
    standalone: true,
    templateUrl: './pagination.component.html',
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() pages: (string | number)[];
  @Input() activePage: string | number;
  @Output() selectPageEvent = new EventEmitter<string | number>();
  visiblePages: (string | number)[] = [];
  indexCurrent: number;

  // Clear flags for first/last page
  isFirstPage = false;
  isLastPage = false;

  constructor() {
  }

  ngOnInit() {
    this.generateVisiblePages();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['pages'] || changes['activePage']) {
      this.generateVisiblePages();
    }
  }

  onSelectPage(page: string | number) {
    this.activePage = page;
    this.generateVisiblePages();
    this.selectPageEvent.emit(this.activePage);
  }

  onSelectPrevious() {
    if (!this.isFirstPage) {
      this.activePage = this.pages[this.indexCurrent - 1];
      this.generateVisiblePages();
      this.selectPageEvent.emit(this.activePage);
    }
  }

  onSelectNext() {
    if (!this.isLastPage) {
      this.activePage = this.pages[this.indexCurrent + 1];
      this.generateVisiblePages();
      this.selectPageEvent.emit(this.activePage);
    }
  }

  generateVisiblePages() {
    if (!this.pages || this.pages.length === 0) {
      this.visiblePages = [];
      this.isFirstPage = true;
      this.isLastPage = true;
      return;
    }

    this.visiblePages = [];
    this.indexCurrent = this.pages.indexOf(this.activePage);

    // Determine if we're at first or last page
    this.isFirstPage = this.indexCurrent === 0;
    this.isLastPage = this.indexCurrent === this.pages.length - 1;

    // Always show max 3 pages centered around current page
    const maxVisible = 3;
    let startIndex: number;
    let endIndex: number;

    if (this.pages.length <= maxVisible) {
      // Show all pages if 3 or fewer
      startIndex = 0;
      endIndex = this.pages.length - 1;
    } else {
      // Center around current page
      startIndex = this.indexCurrent - 1;
      endIndex = this.indexCurrent + 1;

      // Adjust if at the beginning
      if (startIndex < 0) {
        startIndex = 0;
        endIndex = maxVisible - 1;
      }

      // Adjust if at the end
      if (endIndex > this.pages.length - 1) {
        endIndex = this.pages.length - 1;
        startIndex = this.pages.length - maxVisible;
      }
    }

    for (let i = startIndex; i <= endIndex; i++) {
      this.visiblePages.push(this.pages[i]);
    }
  }
}
